module.exports = __webpack_public_path__ + "static/img/9.ee36206.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/carruDepto/9.jpg
// module id = SJ4h
// module chunks = 5